import TextCell from 'components/TextCell';
import type { ManagedFleet } from '../..';

interface CityCellProps {
  rowData: ManagedFleet;
}

export default function CityCell({ rowData: { city } }: CityCellProps) {
  return <TextCell text={city} />;
}
